import { Pipe, PipeTransform } from '@angular/core';
import { ArticleMapping } from '@classes/article/article-mapping';

@Pipe({
    name: 'articleMapping'
})
export class ArticleMappingPipe implements PipeTransform {

    transform(value: ArticleMapping): string {
        let mapping: string;
        if (value.enveloppeL1) {
            mapping = value.enveloppeL1
        }
        if (value.enveloppeL2) {
            mapping += ` -> ${value.enveloppeL2}`
        }
        if (value.enveloppeL3) {
            mapping += ` -> ${value.enveloppeL3}`
        }
        if (value.enveloppeL4) {
            mapping += ` -> ${value.enveloppeL4}`
        }
        if (value.enveloppeL5) {
            mapping += ` -> ${value.enveloppeL5}`
        }
        mapping += ` -> ${value.functionalCode}`

        return mapping
    }

}
